// LIBRARIES
import { createSlice } from "@reduxjs/toolkit";
import { authenticate } from "api/sessionApi";
import { getUser } from "api/sessionApi";

//MISC
import { IUserDetails } from "models/interfaces";

export interface ISessionInitialState {
  token: string;
  language: string;
  isLoading: boolean;
  errorMessage: string;
  userDetails: IUserDetails;
}

const initialState: ISessionInitialState = {
  token: "",
  language: "ro",
  isLoading: false,
  errorMessage: "",
  userDetails: {
    id: 0,
    username: "",
    password: "",
    fullName: "",
    createdAt: "",
    lastUpdate: "",
    firebaseToken: null,
    userStatus: "",
    isInRentalProcess: null,
    currentRentalId: null,
    rentalStatus: "",
    isActive: null,
    referralCode: "",
  },
};

export const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    toggleLanguageState: (state, action) => {
      state.language = action.payload;
    },
    setTokenToInitialState: (state) => {
      state.token = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(authenticate.pending, (state) => {
      state.isLoading = true;
      state.errorMessage = "";
    });
    builder.addCase(authenticate.fulfilled, (state, action) => {
      state.isLoading = false;
      state.token = action.payload.token;
    });
    builder.addCase(authenticate.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.error.message;
      state.token = null;
    });
    builder.addCase(getUser.pending, (state) => {
      state.isLoading = true;
      state.errorMessage = "";
    });
    builder.addCase(getUser.fulfilled, (state, action) => {
      state.isLoading = false;
      state.userDetails = action.payload;
    });
    builder.addCase(getUser.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.error.message;
      state.token = null;
    });
  },
});

export const { toggleLanguageState, setTokenToInitialState } =
  sessionSlice.actions;

export const token = (state) => state.session.token;
export const language = (state) => state.session.language;
export const isLoading = (state) => state.session.isLoading;
export const errorMessage = (state) => state.session.errorMessage;
export const userDetails = (state) => state.session.userDetails;

export default sessionSlice.reducer;
